import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Question, QuestionStatus} from '@cp/model';
import {CHANGE_QUESTION_STATUS} from '../sharedQueries';

export function useChangeQuestionStatus() {
  const [changeQuestionStatusMutation, {loading, error}] = useMutation<
    {changeQuestionStatus: Question},
    {
      moduleId: string;
      questionId: string;
      status: QuestionStatus;
      statusNote?: string;
    }
  >(CHANGE_QUESTION_STATUS);

  const changeQuestionStatus = async (
    moduleId: string,
    questionId: string,
    status: QuestionStatus,
    statusNote?: string,
  ) => {
    const result = await changeQuestionStatusMutation({
      variables: {
        moduleId,
        questionId,
        status,
        statusNote,
      },
    });

    return extractGqlData(result).changeQuestionStatus;
  };

  return {
    changeQuestionStatus,
    loading,
    error,
  };
}
